/**
 * @file Renders a distribution status as a colored tag.
 */
import React from "react";
import { Tag } from "antd";

import {
  getTransactionStatusLabel,
  getTransactionStatusColor,
} from "./TransactionStatusTag";

type Props = {
  status: string;
};

/**
 * Renders the label and the color of the transaction status of a distribution.
 */
const DistributionStatusTag = ({ status }: Props): JSX.Element => {
  const label = getTransactionStatusLabel(status);
  const color = getTransactionStatusColor(status);

  return (
    <Tag
      color={color}
      bordered={false}
    >
      {label}
    </Tag>
  );
};

export default DistributionStatusTag;
